import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { PaymentTermForm } from "../../features/payment-terms/PaymentTermForm"

type Props = {
  payment_term: { id: number; name: string; days: string; active: boolean }
  errors?: Record<string, string[]>
}

export default function DatasPagamentoEdit({ payment_term, errors }: Props) {
  return (
    <>
      <Head title="Editar Condição de Pagamento" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Editar Condição de Pagamento</h1>
            <p className="text-slate-400">Altere nome, dias ou status da condição.</p>
          </div>
          <PaymentTermForm
            initialValues={payment_term}
            submitUrl={`/datas-pagamento/${payment_term.id}`}
            submitLabel="Salvar alterações"
            method="patch"
            errors={errors}
          />
        </div>
      </AppLayout>
    </>
  )
}
